import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Sparkles, ShieldCheck } from "lucide-react";
import api from "../lib/api";

// Shows live per-destination early-bird discounts (set in /panel), or an "ended" message if none are active.
export const EarlyBirdBanner = ({ className = "" }) => {
  const { t } = useTranslation();
  const [deals, setDeals] = useState(null);

  useEffect(() => {
    api.get("/packages").then((r) => {
      const live = (r.data || []).filter((p) => p.bookable !== false && (p.early_bird_discount_percent || 0) > 0);
      setDeals(live);
    }).catch(() => setDeals([]));
  }, []);

  if (deals === null) return null;

  return (
    <div data-testid="early-bird-banner" className={`rounded-xl border border-rr-gold/25 bg-rr-gold/[0.04] px-6 py-5 ${className}`}>
      <div className="flex items-center gap-2.5">
        <Sparkles className="w-4 h-4 text-rr-gold" strokeWidth={1.6} />
        <span className="overline">{t("earlyBird.label")}</span>
      </div>
      {deals.length > 0 ? (
        <div className="flex flex-wrap items-center gap-2.5 mt-3.5" data-testid="early-bird-live">
          <span className="text-rr-ivory/70 text-sm mr-1">{t("earlyBird.live")}</span>
          {deals.map((d) => (
            <span key={d.slug} data-testid={`early-bird-deal-${d.slug}`}
              className="text-sm font-heading text-rr-gold px-3.5 py-1.5 rounded-full border border-rr-gold/30 bg-rr-gold/10">
              {d.name} · {t("earlyBird.save")} {d.early_bird_discount_percent}%
            </span>
          ))}
        </div>
      ) : (
        <p className="text-rr-ivory/60 text-sm mt-3.5" data-testid="early-bird-ended">{t("earlyBird.ended")}</p>
      )}
      <div className="flex items-center gap-2 mt-4 pt-4 border-t border-rr-line">
        <ShieldCheck className="w-4 h-4 text-rr-gold/80 shrink-0" strokeWidth={1.6} />
        <span className="text-rr-ivory/65 text-sm" data-testid="cancellation-note">{t("earlyBird.cancel")}</span>
      </div>
    </div>
  );
};
